<h2 mat-dialog-title>Adding fuel type</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>Enter the name of the fuel type</mat-label>
    <input
      matInput
      [(ngModel)]="data.name"
      maxlength="20"
      name="fuelType"
      #fuelType="ngModel"
    />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button
    mat-button
    cdkFocusInitial
    [mat-dialog-close]="data.name"
    [disabled]="!data.name || fuelType.invalid"
  >
    Add
  </button>
</mat-dialog-actions>
